import PropTypes from 'prop-types';

/**
 * Shared PropType shapes for location-related objects.
 * Re-used across LocationLayout, MapSection, and tile components
 * to keep type definitions DRY.
 */

/** Core location fields used by the map and tiles. */
export const locationShape = PropTypes.shape({
	name: PropTypes.string,
	distance: PropTypes.string,
	isOpen: PropTypes.bool,
	openCloseText: PropTypes.string,
	href: PropTypes.string,
	latitude: PropTypes.number,
	longitude: PropTypes.number
});

/** A tile wrapper that contains a location plus display metadata. */
export const tileDataShape = PropTypes.shape({
	location: locationShape,
	displayType: PropTypes.string
});

/** Latitude / longitude coordinate pair. */
export const coordinatesShape = PropTypes.shape({
	lat: PropTypes.number.isRequired,
	lng: PropTypes.number.isRequired
});
